import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaExchangeAlt, FaFileCsv, FaFilePdf } from 'react-icons/fa';
import '../../styles/pages/InversionesExterior/InversionesExteriorPage.css';

/**
 * Página principal del módulo Inversiones exterior (DJ 1929)
 * Una tarjeta por cada parte del módulo. Cada fuente de datos (Racional,
 * Fintual, PDF, …) tiene su propia tarjeta y su propia página, para revisarla,
 * probarla, quitarla o agregarla sin tocar las demás.
 */
const InversionesExteriorPage = () => {
    const navigate = useNavigate();

    const menuItems = [
        {
            title: 'Racional',
            description: 'CSV «Reporte de operaciones» para la DJ 1929',
            icon: <FaFileCsv />,
            path: '/inversiones-exterior/racional'
        },
        {
            title: 'Fintual',
            description: 'CSV «dj1929_formato_sii» para la DJ 1929',
            icon: <FaFileCsv />,
            path: '/inversiones-exterior/fintual'
        },
        {
            title: 'PDF',
            description: 'Cartolas, reportes, contratos o acuerdos; la IA propone las filas',
            icon: <FaFilePdf />,
            path: '/inversiones-exterior/pdf'
        },
        {
            title: 'Tipos de cambio',
            description: 'Tasas al 31-12 de cada año para pasar a pesos',
            icon: <FaExchangeAlt />,
            path: '/inversiones-exterior/tipos-cambio'
        }
    ];

    return (
        <div className="invext-container">
            <div className="invext-header">
                <h1>Inversiones exterior</h1>
                <p>Declaración Jurada 1929: inversiones y rentas en el exterior</p>
            </div>

            <div className="invext-menu-grid">
                {menuItems.map((item) => (
                    <div
                        key={item.path}
                        className="invext-menu-card"
                        role="button"
                        tabIndex={0}
                        onClick={() => navigate(item.path)}
                        onKeyDown={(e) => e.key === 'Enter' && navigate(item.path)}
                    >
                        <div className="invext-card-icon">
                            {item.icon}
                        </div>
                        <h3>{item.title}</h3>
                        <p>{item.description}</p>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default InversionesExteriorPage;
